import { makeOutlines } from "../../utils/commonUtils";

export const userTriggerEventsList = payload => {

  const { transaction, delegate, allEvents, allTransactions, allUserTriggers, selectedUtEvent } = payload

  let utEdit = false
  if (selectedUtEvent) utEdit = selectedUtEvent;

  const existingEventsAssocaitedUserTriggers = allUserTriggers.map(item => item.attributes.op);

  let alphabeticallyArrangedList = []

  const eventsFromDelegate = allEvents.filter(item => item.src == delegate).map(item => item._id)
  // console.log({eventsFromDelegate})

  const selectedTrans = allTransactions.find(item => item._id == transaction)
  // console.log(selectedTrans)

  const selectedTransEvents = selectedTrans?.events.map(item => item.id);
  // console.log(selectedTransEvents)

  const userTriggerEvents = selectedTransEvents.map(item => {
    if (eventsFromDelegate.includes(item)) return allEvents.find(event => event._id == item)
  }).filter(i => i)
  // console.log(userTriggerEvents)

  const eventsList = userTriggerEvents.map(item => {
    if (existingEventsAssocaitedUserTriggers.includes(item._id) && item._id != utEdit) return { label: item.name, value: item._id, disabled: true }
    else return { label: item.name, value: item._id, disabled: false }
  })

  alphabeticallyArrangedList = eventsList.sort(function (a, b) {
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  })


  return alphabeticallyArrangedList
}

export const getUserTriggersOfSelectedDelegate = (payload) => {
  // console.log(payload)

  const { delegate, allEvents, allTransactions, userTriggers, fields } = payload;

  let userTriggersOfSelectedDelegate = []

  userTriggers.forEach(item => {

    const ut = item;
    const event = item.attributes.op;
    const selectedEvent = allEvents.find(item => item.id === event)

    if (selectedEvent.src === delegate) {

      const field = fields.find(item => {
        const parents = item.parent.map(item => item.id)
        if (parents.includes(ut.id)) return item
      })

      const transaction = allTransactions.find(item => {
        const events = item.events.map(item => item.id)
        if (events.includes(selectedEvent.id)) return item
      })

      const userTrigger = {
        ...item,
        transaction: transaction,
        event: selectedEvent,
        field: field
      }

      userTriggersOfSelectedDelegate.push(userTrigger)
    }
  })
  // console.log(userTriggersOfSelectedDelegate)
  return userTriggersOfSelectedDelegate
}


export const userTriggerEventsListForControllerDelegate = payload => {

  const { transaction, allEvents, allTransactions, allUserTriggers, allClusterlets } = payload

  const selectedTransaction = allTransactions.find(item => item.id === transaction)

  const events = selectedTransaction.events.map(item => item.id)

  const eventsFromDelegates = allEvents
    .filter(item => events.includes(item.id))
    .filter(item => allClusterlets.find(c => c.id === item.src).type === 1)


  const existingEventsAssocaitedUserTriggers = allUserTriggers.map(item => item.attributes.op);

  const eventsList = eventsFromDelegates.map(item => {
    if (existingEventsAssocaitedUserTriggers.includes(item.id)) return { label: item.name, value: item.id, disabled: true }
    else return { label: item.name, value: item.id, disabled: false }
  })

  let alphabeticallyArrangedList = []

  alphabeticallyArrangedList = eventsList.sort(function (a, b) {
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  })

  return alphabeticallyArrangedList

}



// export const userTriggersOfDelegate = (payload) => (state) => {

//   const { delegate } = payload;
//   let userTriggersOfSelectedDelegate = [];

//   let user_triggers = getUserTriggers(state);

//   user_triggers.forEach(item => {
//     const ut = item;
//     const event = item.attributes.op;
//     const selectedEvent = state.constructs.events.find(item => item.id === event);
//     if (selectedEvent?.src === delegate) {

//       const field = state.constructs.fields.find(item => {

//         const parents = item.parent.map(item => item.id)
//         if (parents.includes(ut.id)) return item;

//       });

//       const transaction = state.constructs.transactions.find(item => {

//         const events = item.events.map(item => item.id)
//         if (events.includes(selectedEvent.id)) return item;

//       });

//       const userTrigger = {
//         ...item,
//         transaction: transaction,
//         event: selectedEvent,
//         field: field
//       }

//       userTriggersOfSelectedDelegate.push(userTrigger)
//     }

//   })

//   // const alphabeticallyArrangedList = userTriggersOfSelectedDelegate.sort(function (a, b) {
//   //   return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
//   // })

//   // return alphabeticallyArrangedList
//   return userTriggersOfSelectedDelegate
// }


export const mainTransInAlphabeticalOrder = (trans) => {


  const transactions = trans.filter((tr) => tr.type === 7);;

  const transInAlphabeticalOrder = transactions.sort(function (a, b) {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  })

  const transList = transInAlphabeticalOrder.map(item => { return { label: item.name, value: item._id } })
  return transList;
}

export const userTriggersOfEvent = ({ event, constructs }) => {


  let userTriggers = constructs.userTriggers.filter(item => item.attributes.op == event);
  let uts = JSON.parse(JSON.stringify(userTriggers));

  uts.forEach(ut => {
    const event = constructs.events.find(event => event._id == ut.attributes.op);
    const transaction = constructs.transactions.find(item => {
      const events = item.events.map(element => element.id)
      if (events.includes(ut.attributes.op)) return item
    });
    const field = constructs.fields.find(item => {
      const parents = item.parent.map(element => element.id)
      if (parents.includes(ut._id)) return item
    });

    ut.event = event;
    ut.transaction = transaction;
    ut.field = field;
  })

  const alphabeticallyArrangedList = uts.sort(function (a, b) {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  })

  return alphabeticallyArrangedList;
}


export const fetchSelectedUserTrigger = (payload) => {


  const { userTriggerId, userTriggers, events, transactions, fields } = payload;

  const userTrigger = userTriggers.find(item => item._id == userTriggerId)

  const delegate = events.find(item => item._id == userTrigger.attributes.op)?.src;

  const transaction = transactions.find(item => {

    const events = item.events.map(item => item.id)
    if (events.includes(userTrigger.attributes.op)) return item;

  })

  const field = fields.find(item => {

    const parents = item.parent.map(item => item.id)
    if (parents.includes(userTriggerId)) return item

  })


  const selectedUserTrigger = {
    ...userTrigger,
    transaction: transaction,
    field: field,
    delegate: delegate

  }

  // console.log(selectedUserTrigger)
  return selectedUserTrigger

}


export const getUserTriggersOfDelegate = ({ constructs, delegate }) => {

  let userTriggersOfSelectedDelegate = [];

  constructs?.userTriggers.sort((a, b) => a.order - b.order).forEach(item => {

    const ut = item;
    const event = item.attributes.op;
    const selectedEvent = constructs.events.find(ele => ele._id === event);
    if (selectedEvent?.src === delegate) {

      const field = constructs.fields.find(item => {

        const parents = item.parent.map(item => item.id)
        if (parents.includes(ut._id)) return item;

      });

      const transaction = constructs.transactions.find(item => {

        const events = item.events.map(item => item.id)
        if (events.includes(selectedEvent._id)) return item;

      });

      const userTrigger = {
        ...item,
        transaction: transaction,
        event: selectedEvent,
        field: field
      }

      userTriggersOfSelectedDelegate.push(userTrigger)
    }

  })

  return userTriggersOfSelectedDelegate
}

export const getUtNestedData = (fields, allFields, messages) => {


  let childrenFields = JSON.parse(JSON.stringify(fields));

  let utFields = childrenFields.map(fd => {
    const elementAndChildren = findChildren(fd, [], allFields, messages)
    return elementAndChildren
  })

  return utFields
}

const fieldAsChildrenNodes = [11, 17, 22, 12]

export const findChildren = (node, sections, fields, messages) => {

  if (fieldAsChildrenNodes.includes(node?.type) === true && node.attributes.type == 'struct') {
    const children = fields?.filter(s => s.parent[0].id === node._id)
    node.children = []
    children.forEach(c => {
      c.children = []
      c.children.push(findChildren(c, sections, fields))
    })
    node.children = children
  }
  if (node?.type === 12 && node.attributes.type != 'struct') {
    const children = fields?.filter(s => s.parent[0].id === node._id)
    node.children = []
    children.forEach(c => {
      c.children = []
      c.children.push(findChildren(c, sections, fields))
    })
    if (children.length > 0) {
      node.children = children
    } else {
      delete node.children
    }
  }
  // For message as type of message fields
  if (messages) {
    const message = messages.find(item => item._id.toString() == node?.attributes?.type);
    if (message) {
        node.attributes.type = message.name;
        const children = fields?.filter(s => s.parent[0].id == message._id)
        children.forEach(c => {
            c.children = []
            c.children.push(findChildren(c, sections, fields, messages))
        })
        node.children = children;
    }
}
  return node;
}

export const customizeUtExtensionForm = (data) => {


  // For customize payload field
  let payloadDivs;
  if (data.payload) {
    payloadDivs = document.querySelectorAll(`[data-schemapath="utriggers.payload"]`);
  } else {
    payloadDivs = document.querySelectorAll(`[data-schemapath="utriggers.payload"]`);
  }

  if (payloadDivs?.length > 0) {
    payloadDivs.forEach(payloadDiv => {

      makeOutlines(payloadDiv,data.payload,'utriggers.payload')

      // For customising properties button 
      const propertiesBtn = payloadDiv.querySelectorAll('.json-editor-btn-edit_properties.json-editor-btntype-properties');
      if (propertiesBtn?.length > 0) {
        propertiesBtn.forEach(btn => {
          btn.textContent = "Choose Field";
          btn.title = "Choose Field";
        });
      }

      const payloadCard = payloadDiv.querySelector('.card.card-body')
      if (payloadCard) {
        payloadCard.classList.add('payload-container');
        // For replace field input field with label
        const inputElements = payloadCard.querySelectorAll('input[id^="utriggers[payload]"][id$="[field]"]');
        if (inputElements?.length > 0) {
          inputElements.forEach(inputElement => {
            const labelElement = document.createElement('p');
            labelElement.style.fontFamily = 'Roboto, Helvetica'
            labelElement.classList.add('field-label');
            const fieldRequired = inputElement.parentNode.querySelector('label.required');
            let parentElement = inputElement.parentElement;
            while (parentElement) {
              if (parentElement.classList.contains('je-object__container')) {
                break;
              }
              parentElement = parentElement.parentElement;
            }
            if (parentElement) {
              const h3Element = parentElement.querySelector('.h3');
              if (h3Element) {
                h3Element.style = "display: none;"
                labelElement.textContent = h3Element.textContent;
              } else {
                labelElement.textContent = inputElement.value;
              }
            } else {
              labelElement.textContent = inputElement.value;
            }


            // For adding required asterisk
            if (fieldRequired !== null) {
              const containsSpan = labelElement.querySelector('span') !== null;
              if (!containsSpan) {
                const asterisk = document.createElement('span');
                asterisk.textContent = ' *';
                asterisk.style = 'color: red;';
                labelElement.appendChild(asterisk);
              }
            }
            inputElement.parentNode.replaceChild(labelElement, inputElement);
          });
        }

        // For remove label from fields in payload section
        const labelElements = payloadCard.querySelectorAll('label');
        labelElements.forEach(labelElement => {
          if (labelElement.parentNode?.classList.contains('form-group')) {
            labelElement.parentNode.removeChild(labelElement);
          }
        });
      }
    });
  }

}


export const userTriggerSchema = {
  type: 'object',
  required: ['payload'],
  title: "",
  options: {
    layout: 'grid',
    disable_properties: 'false'
  },
  properties: {
    // userTrigger: {
    //   title: 'UserTigger',
    //   type: 'string',
    //   type: 'string',
    //   readOnly: true,
    //   format: "grid",
    //   options: {
    //     layout: 'grid',
    //     grid_columns: 12,
    //   }
    // }
  }

}

export const convertToCustomArray = (data) => {
  const result = [];

  function processObject(obj, parentId = '') {
    for (const key in obj) {
      if (typeof obj[key] === 'object' && obj[key].nodeId == undefined) {
        processObject(obj[key]);
      }
      else {
        const currentId = obj[key].nodeId
        const currentValue = obj[key].value
        result.push({ field: currentId, default: currentValue });

      }
    }
  }

  processObject(data);

  return result;
}



